export var SequenceMode;
(function (SequenceMode) {
    SequenceMode[SequenceMode["Default"] = 0] = "Default";
    SequenceMode[SequenceMode["Playback"] = 1] = "Playback";
    SequenceMode[SequenceMode["Timeline"] = 2] = "Timeline";
})(SequenceMode || (SequenceMode = {}));
//# sourceMappingURL=SequenceMode.js.map